import { Component, HostBinding, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { SystemMessagesService } from '@portal-core/system-messages/services/system-messages.service';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { Subscription } from 'rxjs';
import { SystemMessageCardsComponent } from '@portal-core/system-messages/components/system-message-cards/system-message-cards.component';

@Component({
    selector: 'mc-app-gutter',
    templateUrl: './app-gutter.component.html',
    styleUrls: ['./app-gutter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [SystemMessageCardsComponent]
})
@AutoUnsubscribe()
export class AppGutterComponent implements OnInit {
  private readonly systemMessagesService = inject(SystemMessagesService);

  @HostBinding('class.mc-app-gutter-has-messages')
  get _hasMessages() {
    return this.hasMessages;
  }

  hasMessages = false;
  hasMessagesSubscription: Subscription;

  ngOnInit() {
    this.hasMessagesSubscription = this.systemMessagesService.getItems$().subscribe(messages => {
      this.hasMessages = messages && Object.values(messages).length > 0;
    });
  }
}
